import { z } from 'zod';
import { ApprovalTaskTab } from './-constants';
export const SearchSchema = z.object({
  taskTab: z.nativeEnum(ApprovalTaskTab).default(ApprovalTaskTab.PENDING_APPROVAL).catch(ApprovalTaskTab.PENDING_APPROVAL),
  page: z.number().int().min(1).default(1).catch(1),
  pageSize: z.number().int().min(1).default(20).catch(20)
});